// extracted by mini-css-extract-plugin
module.exports = {"vGray10":"#cfd4dd","vGray14":"#7d85a4","header":"MessengerHeader_header__2LIOD","headerTop":"MessengerHeader_headerTop__2y7gy","headerBottom":"MessengerHeader_headerBottom__1jmG9"};